import { types } from 'mobx-state-tree';

export const SortModel = types.model({
    key: types.string,
    type: types.maybe(types.string),
    name: types.maybe(types.string),
    checked: types.boolean,
    default: types.maybe(types.boolean)
});
